/**
 * Planning & Task Management Module Types
 * Domain-agnostic planning types for objectives and tasks
 */
// ============================================
// ENUMS & CONSTANTS
// ============================================
export var ObjectiveStatus;
(function (ObjectiveStatus) {
    ObjectiveStatus["DRAFT"] = "DRAFT";
    ObjectiveStatus["APPROVED"] = "APPROVED";
    ObjectiveStatus["ACTIVE"] = "ACTIVE";
    ObjectiveStatus["COMPLETED"] = "COMPLETED";
    ObjectiveStatus["CANCELLED"] = "CANCELLED";
})(ObjectiveStatus || (ObjectiveStatus = {}));
export var TaskStatus;
(function (TaskStatus) {
    TaskStatus["PENDING"] = "PENDING";
    TaskStatus["APPROVED"] = "APPROVED";
    TaskStatus["SCHEDULED"] = "SCHEDULED";
    TaskStatus["IN_PROGRESS"] = "IN_PROGRESS";
    TaskStatus["COMPLETED"] = "COMPLETED";
    TaskStatus["CANCELLED"] = "CANCELLED";
})(TaskStatus || (TaskStatus = {}));
//# sourceMappingURL=Planning.js.map